/**
 * Pobranie pliku wygenerowanego w przeglądarce (Blob → link `download` → zwolnienie URL).
 *
 * Wzorzec powtarzał się ręcznie w kilku miejscach (eksporty CSV, raporty); nowe miejsca używają
 * tego helpera. Starych świadomie nie migrujemy przy okazji.
 */

export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Zwolnienie po chwili — natychmiastowe potrafi przerwać pobieranie w części przeglądarek.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Zapisuje dane jako sformatowany plik JSON (UTF-8). */
export function downloadJson(data: unknown, fileName: string): void {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: 'application/json;charset=utf-8',
  });
  downloadBlob(blob, fileName);
}

/**
 * Bezpieczna nazwa pliku z tekstu użytkownika: polskie litery zostają, znaki niedozwolone
 * w nazwach plików (Windows/macOS) zamienione na `-`, spacje na `-`.
 */
export function toFileNamePart(text: string, fallback = 'plik'): string {
  const cleaned = Array.from(text.trim(), (ch) => (ch.charCodeAt(0) < 32 ? '-' : ch))
    .join('')
    .replace(/[\\/:*?"<>|]+/g, '-')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^[-.]+|[-.]+$/g, '')
    .slice(0, 80);
  return cleaned || fallback;
}
